import { createAsyncThunk } from '@reduxjs/toolkit';
import { WishlistAnalyzer } from '../../client/services';
import { toastHandler } from '../../utils/toastHandler';

export interface WishlistAnalyticsParams {
  startDate?: string;
  endDate?: string;
  possessionTypeId?: string;
  locationId?: string;
  categoryId?: string;
  subCategoryId?: string;
  search?: string;
  limit?: number;
  skip?: number;
}

export interface WishlistAnalyticsResponse {
  total: number;
  limit: number;
  skip: number;
  summary: {
    total: number;
    forSale: number;
    forRent: number;
    byLocation: Array<{
      locationId: string;
      locationName: string;
      count: number;
    }>;
    byCategory: Array<{
      categoryId: string;
      categoryName: string;
      count: number;
    }>;
    bySubCategory: Array<{
      subCategoryId: string;
      subCategoryName: string;
      count: number;
    }>;
  };
  data: Array<{
    id: string;
    name: string;
    matchingAdsCount: number;
    possessionType: string;
    possessionTypeId: string;
    location: string;
    locationId: string;
    locationIds?: string[];
    locations?: Array<{
      locationId: string;
      locationName: string;
    }>;
    category: string;
    categoryId: string;
    subCategory: string;
    subCategoryId: string;
    minPrice: number;
    maxPrice: number;
    userName: string;
    userEmail: string;
    userId: string;
    createdAt: string;
  }>;
}

export const getWishlistAnalytics = createAsyncThunk(
  'wishlistAnalyzer/getWishlistAnalytics',
  async (params: WishlistAnalyticsParams, { rejectWithValue }) => {
    try {
      const response = await WishlistAnalyzer.find({
        query: params,
      });
      return response as WishlistAnalyticsResponse;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

